import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a4396fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PlanPackageImportSettings-container container-fluid" }
const _hoisted_2 = { class: "row pt-2" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { style: {"max-width":"360px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Вкладка", -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Номер первой строки данных", -1))
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Номер строки заголовков полей и свойств ", -1))
const _hoisted_12 = {
  key: 0,
  class: "Changes-warning"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, "Сохранить", -1))
const _hoisted_14 = { class: "row pt-2" }
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Поля\\Свойства", -1))
const _hoisted_17 = { class: "col-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Длины", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Номер строки заголовков длин", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Префикс колонки длины", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Префикс колонки объема", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_CatalogueGrid = _resolveComponent("CatalogueGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.model.name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_TextControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Наименование...",
            "show-clear-button": true,
            value: _ctx.model.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.name) = $event)),
            hasEmptyValue: false,
            onChanged: _ctx.haveChanges
          }, null, 8, ["value", "onChanged"]),
          _hoisted_6,
          _createVNode(_component_TextControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Вкладка...",
            "show-clear-button": true,
            value: _ctx.model.sheetName,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.sheetName) = $event)),
            hasEmptyValue: true,
            onChanged: _ctx.haveChanges
          }, null, 8, ["value", "onChanged"]),
          _createVNode(_component_DxCheckBox, {
            class: "Import-checkbox",
            value: _ctx.model.isClearBeforeImport,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.isClearBeforeImport) = $event)),
            text: "Очистка данных",
            onValueChanged: _ctx.haveChanges
          }, null, 8, ["value", "onValueChanged"]),
          _createVNode(_component_DxCheckBox, {
            class: "Import-checkbox",
            value: _ctx.model.isImportToLastNonEmptyRow,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.isImportToLastNonEmptyRow) = $event)),
            text: "Чтение до последней непустой строки",
            onValueChanged: _ctx.haveChanges
          }, null, 8, ["value", "onValueChanged"]),
          _createVNode(_component_DxCheckBox, {
            class: "Import-checkbox",
            value: _ctx.model.isExportCalculationResults,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.isExportCalculationResults) = $event)),
            text: "Выгружать результаты расчета",
            onValueChanged: _ctx.haveChanges
          }, null, 8, ["value", "onValueChanged"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Номер первой строки данных...",
              "show-clear-button": true,
              hasEmptyValue: true,
              value: _ctx.model.firstDataRowNumber,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.firstDataRowNumber) = $event)),
              onChanged: _ctx.haveChanges
            }, null, 8, ["value", "onChanged"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Номер строки заголовков полей и свойств...",
              "show-clear-button": true,
              hasEmptyValue: true,
              value: _ctx.model.fieldPropertyRowNumber,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.fieldPropertyRowNumber) = $event)),
              onChanged: _ctx.haveChanges
            }, null, 8, ["value", "onChanged"])
          ])
        ]),
        (_ctx.changes)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Изменения вступят в силу после сохранения "))
          : _createCommentVNode("", true),
        _createVNode(_component_DxButton, {
          class: "Import-saveButton",
          type: "default",
          onClick: _ctx.onSave,
          "styling-mode": "outlined"
        }, {
          content: _withCtx(() => [
            _createElementVNode("span", null, [
              (_ctx.saving)
                ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                    key: 0,
                    icon: "circle-notch",
                    spin: ""
                  }))
                : _createCommentVNode("", true),
              _hoisted_13
            ])
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        (_ctx.model.id)
          ? (_openBlock(), _createBlock(_component_CatalogueGrid, {
              key: 0,
              controller: 'PlanPackageImportSettingsItem',
              columns: _ctx.columns,
              filterRowVisible: false,
              groupPanelVisible: false,
              headerFilterVisible: false,
              filterPanelVisible: false,
              showPageSizeSelector: true,
              pageSize: 20,
              pageSizes: _ctx.pageSizes,
              editingConfig: _ctx.editingConfig,
              selectionConfig: _ctx.selectionConfig,
              designConfig: _ctx.designConfig,
              parentModel: _ctx.model,
              popupCreateEditComponent: _ctx.planPackageSettingsItemCreateEditDialog,
              selectMode: _ctx.selectMode
            }, null, 8, ["columns", "pageSizes", "editingConfig", "selectionConfig", "designConfig", "parentModel", "popupCreateEditComponent", "selectMode"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _hoisted_19,
        _createVNode(_component_IntegerControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Номер строки заголовков длин...",
          "show-clear-button": true,
          hasEmptyValue: true,
          value: _ctx.model.lengthsRowNumber,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.lengthsRowNumber) = $event)),
          onChanged: _ctx.haveChanges
        }, null, 8, ["value", "onChanged"]),
        _hoisted_20,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Префикс колонки длины...",
          "show-clear-button": true,
          value: _ctx.model.lengthColumnPrefix,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.lengthColumnPrefix) = $event)),
          disabled: _ctx.model.isReadLengthFromColumnTitle,
          hasEmptyValue: _ctx.model.isReadLengthFromColumnTitle,
          onChanged: _ctx.haveChanges
        }, null, 8, ["value", "disabled", "hasEmptyValue", "onChanged"]),
        _hoisted_21,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Префикс колонки объема...",
          "show-clear-button": true,
          value: _ctx.model.volumeColumnPrefix,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.volumeColumnPrefix) = $event)),
          disabled: _ctx.model.isReadLengthFromColumnTitle,
          hasEmptyValue: _ctx.model.isReadLengthFromColumnTitle,
          onChanged: _ctx.haveChanges
        }, null, 8, ["value", "disabled", "hasEmptyValue", "onChanged"]),
        _createVNode(_component_DxCheckBox, {
          class: "Import-checkbox",
          value: _ctx.model.isReadLengthFromColumnTitle,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.isReadLengthFromColumnTitle) = $event)),
          text: "Поиск и чтение длин с заголовков колонок",
          onValueChanged: _ctx.haveChanges
        }, null, 8, ["value", "onValueChanged"]),
        _createVNode(_component_DxCheckBox, {
          class: "Import-checkbox",
          value: _ctx.model.isLengthInMeters,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.isLengthInMeters) = $event)),
          text: "Длина в метрах",
          onValueChanged: _ctx.haveChanges
        }, null, 8, ["value", "onValueChanged"]),
        _createVNode(_component_DxCheckBox, {
          class: "Import-checkbox",
          value: _ctx.model.isSkipVolumes,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.isSkipVolumes) = $event)),
          text: "Импортировать длины без объемов",
          onValueChanged: _ctx.haveChanges
        }, null, 8, ["value", "onValueChanged"])
      ])
    ])
  ]))
}